import React from 'react';
import DynamicFormViewer from '../../Components/FormData/DynamicFormViewer';
import {
  getAllcallBacks,
  deleteCallBack,
  updateCallBackById,
} from '../../Redux/Store/API/FormsData/callBack';

export default function CallBacksFormData() {
  const headers = [
    { key: 'firstname', label: 'First Name' },
    { key: 'lastname', label: 'Last Name' },
    { key: 'mobileNo', label: 'Mobile No' },
    { key: 'subject', label: 'Subject' },
    { key: 'query', label: 'Query / Message' },
    { key: 'sourcePage', label: 'Source Page', render: (v) => v || '—' },
  ];

  return (
    <DynamicFormViewer
      title="Call Back Requests"
      headers={headers}
      fetchAction={getAllcallBacks}
      deleteAction={deleteCallBack}
      updateAction={updateCallBackById}
      stateSliceName="callBack"
      dataKey="getallcallBacks"
    />
  );
}